import React from 'react';
import styles from './ApplicationSingleEmailAttachmentDownloadSnackbar.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { ReduxState } from 'types/redux';
import LoaderWithState, { LoaderState } from 'components/LoaderWithState';
import { DocumentDownloadingState } from 'LoanOriginationSystemApplicationPage/Documents/Types';
import { FileIcon } from 'static/images';
import { DOCUMENT_DOWNLOADING_SNACK_LIFE_DURATION } from 'Snackbar/Middleware';
import { EmailAttachment } from 'api/LoanOriginationSystem/LoanOriginationSystemEmailsApi';
import { removeDownloadedEmailAttachment } from 'LoanOriginationSystemEmails/ActionCreator';
import { iconsByExtension } from 'components/LoanOriginationSystem/ApplicationTabs/DocumentsTab/ApplicationDocumentsTable/ApplicationDocumentItemRow/ApplicationDocumentItemRow';
import { getAbbreviatedTextLine } from 'utils/getAbbreviatedString';

export interface ApplicationSingleEmailAttachmentDownloadSnackbarProps {
  attachment: EmailAttachment;
  attachmentDownloadingId: string;
}

const MAX_ATTACHMENT_NAME_LENGTH = 38;

const ApplicationSingleEmailAttachmentDownloadSnackbar = ({
  attachment,
  attachmentDownloadingId,
}: ApplicationSingleEmailAttachmentDownloadSnackbarProps) => {
  const dispatch = useDispatch();

  const emailAttachmentsDownloadingState: DocumentDownloadingState = useSelector(
    (state: ReduxState) => state.loanOriginationSystemEmails.downloadableAttachments[attachmentDownloadingId],
  );

  const onDocumentDownloadingStateReset = () => {
    dispatch(removeDownloadedEmailAttachment(attachmentDownloadingId));
  };

  return (
    <div className={styles.documentContainer}>
      <div className={styles.documentIcon}>{iconsByExtension.get(attachment.type) || <FileIcon />}</div>
      <div className={styles.documentName}>{getAbbreviatedTextLine(attachment.name, MAX_ATTACHMENT_NAME_LENGTH)}</div>
      <LoaderWithState
        state={emailAttachmentsDownloadingState === 'loading' ? LoaderState.Updating : emailAttachmentsDownloadingState as LoaderState}
        onStateReset={onDocumentDownloadingStateReset}
        className={styles.loader}
        successTimeout={DOCUMENT_DOWNLOADING_SNACK_LIFE_DURATION}
        failureTimeout={DOCUMENT_DOWNLOADING_SNACK_LIFE_DURATION}
      />
    </div>
  );
};

export default ApplicationSingleEmailAttachmentDownloadSnackbar;
